import { render, staticRenderFns } from "./clinicalGuidelinesItme.vue?vue&type=template&id=6e0792b0&scoped=true&"
import script from "./clinicalGuidelinesItme.vue?vue&type=script&lang=js&"
export * from "./clinicalGuidelinesItme.vue?vue&type=script&lang=js&"
import style0 from "./clinicalGuidelinesItme.vue?vue&type=style&index=0&id=6e0792b0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0792b0",
  null
  
)

export default component.exports